var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEMO_INITIATIVE_LABEL_IDS, getDemoActivityLabelName } from '@web/lib/demo/data/labels';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { formatDuration, getPercentageDiff } from '@workalizer/shared/utils';
var createAmountMetric = function (current, prev, teamAvg) { return ({
    current: current,
    previous: getPercentageDiff(prev, current),
    teamAverage: getPercentageDiff(teamAvg, current, {
        comparisonType: diffComparisonType.teamAverage
    })
}); };
var createDurationMetric = function (currentSeconds, prevSeconds, teamAvgSeconds) { return ({
    current: formatDuration(currentSeconds, 'seconds'),
    previous: getPercentageDiff(prevSeconds, currentSeconds, {
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds
    }),
    teamAverage: getPercentageDiff(teamAvgSeconds, currentSeconds, {
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds,
        comparisonType: diffComparisonType.teamAverage
    })
}); };
var createParticipantsMetric = function (current, prev) { return ({
    current: current,
    previous: getPercentageDiff(prev, current)
}); };
var topRecurringEventsAndMeetingsRows = [
    {
        totalAmount: createAmountMetric(8, 6, 7),
        totalDuration: createDurationMetric(45000, 37500, 50000),
        numberOfParticipants: createParticipantsMetric(24, 16)
    },
    {
        totalAmount: createAmountMetric(5, 6, 4),
        totalDuration: createDurationMetric(31500, 37000, 25200),
        numberOfParticipants: createParticipantsMetric(18, 14)
    },
    {
        totalAmount: createAmountMetric(3, 0, 4),
        totalDuration: createDurationMetric(22500, 12800, 28000),
        numberOfParticipants: createParticipantsMetric(12, 0)
    },
    {
        totalAmount: createAmountMetric(12, 12, 11),
        totalDuration: createDurationMetric(36000, 36000, 33300),
        numberOfParticipants: createParticipantsMetric(36, 36)
    },
    {
        totalAmount: createAmountMetric(2, 4, 2),
        totalDuration: createDurationMetric(12600, 16800, 12000),
        numberOfParticipants: createParticipantsMetric(8, 10)
    }
];
export var topRecurringEventsAndMeetings = function () {
    return DEMO_INITIATIVE_LABEL_IDS.map(function (labelId, index) { return (__assign({ labelName: getDemoActivityLabelName(labelId) }, topRecurringEventsAndMeetingsRows[index])); });
};
